import './MainPage.css';

import Header from '../Header/Header';
import ComoFunciona from '../ComoFunciona/ComoFunciona';
import Desafios from '../Desafios/Desafios';
import AssistaVideo from '../AssistaVideo/AssistaVideo';
import BaixarApp from '../BaixarApp/BaixarApp';
import Cadastrar from '../Cadastrar/Cadastrar';
import Footer from '../Footer/Footer';

import Obrigado from '../Obrigado/Obrigado';

function MainPage() {
  return (
    <div className="mainContainer">
      {window.location.pathname === "/obrigado"
      ?
      <Obrigado />
      :
      <>
        <Header />
        <ComoFunciona />
        <Desafios />
        <AssistaVideo />
        <BaixarApp />
        <Cadastrar />
        <Footer />
      </>
      }
    </div>
  );
}

export default MainPage;
